import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MunicipioService } from '@app/modules/parametrizacao/municipio/services/municipio.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import {
  CepService,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { IParceiro, IParceiroEndereco } from '../../model';
import { IConsultaPredictusPessoaFisica } from '../../model/consulta_predictus_pf.model';
import { IConsultaPredictusPessoaJuridica } from '../../model/consulta_predictus_pj.model';
import { ParceiroService } from '../../services';

@Component({
  selector: 'dialog-consulta-predictus',
  templateUrl: './dialog-consulta-predictus.component.html',
  providers: [ParceiroService, MunicipioService]
})
export class DialogConsultaPredictusComponent {
  searchingCep = false;
  pessoaFisica: IConsultaPredictusPessoaFisica;
  pessoaJuridica: IConsultaPredictusPessoaJuridica;

  constructor(
    public router: Router,
    public matSnackBar: MatSnackBar,
    protected tokenService: TokenService,
    protected parceiroService: ParceiroService,
    protected cepService: CepService,
    protected municipioService: MunicipioService,
    public matDialogRef: MatDialogRef<DialogConsultaPredictusComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { data: any; usaCnae: boolean }
  ) {
    if (dialogData.data.cpf)
      this.pessoaFisica = dialogData.data as IConsultaPredictusPessoaFisica;
    else
      this.pessoaJuridica = dialogData.data as IConsultaPredictusPessoaJuridica;
  }

  usarDados() {
    this.searchingCep = true;
    if (this.dialogData.data.enderecos.length === 0) {
      this.closeDialogAndSendData([
        {
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          ponto_referencia: ''
        }
      ] as IParceiroEndereco[]);
    } else {
      const {
        cep,
        logradouro,
        numero,
        complemento,
        bairro
      } = this.dialogData.data.enderecos[0];

      const enderecos = [
        {
          cep,
          logradouro,
          numero,
          complemento,
          bairro
        } as IParceiroEndereco
      ];

      this.cepService.getAddres(cep).subscribe(
        (addres: any) => {
          if ((addres as any).erro === 'true') {
            this.searchingCep = false;
            this.closeDialogAndSendData(enderecos);
            this.matSnackBar.open('Cep não encontrado!', 'X', {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          } else {
            if (addres.ibge && addres.localidade) {
              this.municipioService
                .getEntitiesByParams(`codigo_ibge=${addres.ibge}`)
                .subscribe(
                  municipios => {
                    this.searchingCep = false;
                    if (municipios && municipios.length) {
                      enderecos[0].municipio = municipios[0];
                      enderecos[0].municipio_id = municipios[0].id;
                    } else enderecos[0].municipio = addres.localidade;
                    this.closeDialogAndSendData(enderecos);
                  },
                  (err: HttpErrorResponse) => {
                    this.searchingCep = false;
                    this.closeDialogAndSendData([]);
                    this.displayError(err);
                  }
                );
            }
          }
        },
        (erro: HttpErrorResponse) => {
          if (erro.message) {
            this.searchingCep = false;
            this.closeDialogAndSendData(enderecos);
            this.matSnackBar.open('Cep não encontrado!', 'X', {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        }
      );
    }
  }

  closeDialogAndSendData(enderecos: IParceiroEndereco[]) {
    this.matDialogRef.close(({
      cpf_cnpj: this.dialogData.data.cpf || this.dialogData.data.cnpj,
      nome_razao_social:
        this.dialogData.data.nome || this.dialogData.data.razaoSocial,
      apelido_nome_fantasia: this.dialogData.data.nomeFantasia
        ? this.dialogData.data.nomeFantasia
        : (this.dialogData.data.nome || this.dialogData.data.razaoSocial),
      rg_insc_est: this.dialogData.data.rg,
      enderecos,
      active: true,
      domain_id: this.tokenService.getDomain().id,
      contatos: this.dialogData.data.contatos,
      data_nascimento: new Date(
        (this.dialogData.data.dataNascimento ||
          this.dialogData.data.dataAbertura) + 'T00:00:00'
      ),
      cnae:
        this.dialogData.data.cnpj && this.dialogData.usaCnae
          ? this.dialogData.data.descricaoCnaePrincipal
          : undefined
    } as unknown) as IParceiro);
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = true) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.dialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'pi pi-fw pi-exclamation-triangle text-orange-500 mr-2 mb-2',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
